import { Component, OnInit } from '@angular/core';
import { BeneficiariesService } from '../services/beneficiaries.service';
import { Beneficiaries } from '../models/beneficiaries.model';
import { SpinnerService } from '../services/spinner.service';

@Component({
  selector: 'app-beneficiaries',
  templateUrl: './beneficiaries.component.html',
  styleUrls: ['./beneficiaries.component.scss']
})
export class BeneficiariesComponent implements OnInit {

  public beneficiariesList: Array<Beneficiaries[]>;

  constructor(
    private beneficiariesService: BeneficiariesService,
    private spinnerService: SpinnerService
  ) {

  }

  ngOnInit() {
    this.getAllBeneficiaries();
  }

  public getAllBeneficiaries() {
    this.spinnerService.updatedState(true);
    this.beneficiariesService.getAll().subscribe(
      (data: any) => {
        this.beneficiariesList = new Array<Beneficiaries[]>();
        Object.assign(this.beneficiariesList, data);
        this.spinnerService.updatedState(false);
      },
      (err) => {
        console.log(err);
        this.spinnerService.updatedState(false);
      }
    );
  }

}
